<div class="search-header-container mt-3 mb-3" *ngIf="!hideHeader">{{ header }}</div>
<div [ngClass]="{'refresh-icon-aligned': shouldAlignIcon}" class="search-refresh" (click)="refresh()" *ngIf="showRefresh">
    <mat-icon svgIcon="{{ icon }}"></mat-icon>
</div>
<div class="search-refresh" (click)="clearCache()" *ngIf="showClearCache">
    <mat-icon svgIcon="delete-history"></mat-icon>
</div>
<div class="search-refresh" (click)="create()" *ngIf="showCreate">
  <mat-icon svgIcon="create"></mat-icon>
</div>
<div class="search-refresh" (click)="history()" *ngIf="showHistory">
  <mat-icon svgIcon="history-clock-button"></mat-icon>
</div>
<div class="row col-12">
<div class="input-group" [ngClass]="{ 'col-md-8': showDropDownFilter }">
  <div class="input-group-prepend" *ngIf="showSearch && showKeyboard" (click)="toggleKeyboard()">
    <span class="input-group-text">
      <mat-icon svgIcon="keyboard"></mat-icon>
    </span>
  </div>

  <input appScannerDetect (onDetected)="onDetected($event)" (onDelete)="onDelete()" #searchInputField [disableKeyPress]="disableKeyPress" 
    [disabled]="isReadonly" type="text" [(ngModel)]="searchInput" class="form-control scanner-input" placeholder="{{ placeholder }}"
    *ngIf="showSearch" [attr.inputmode]="getInputMode"/>

  <div class="input-group-append" *ngIf="showSearch && showClear" (click)="clearSearchInput()">
    <span class="input-group-text">
      <mat-icon svgIcon="delete-outline"></mat-icon>
    </span>
  </div>

    <div class="search-date-filter" *ngIf="showDateFilter">
      <input type="date" class="form-control" [(ngModel)]="dateFilterValue" (change)="onDateFilterChange($event)">
    </div>
  </div>
  <div *ngIf="showDropDownFilter" class="col-md-4">
    <div style="display: flex">
      <label class="form-label" style="margin-right: 10px">FILTER</label>
      <select class="form-control">
        <option selected>ALL</option>
        <option
          [ngValue]="physicalLocation"
          *ngFor="let physicalLocation of physicalLocations"
        >
          {{ physicalLocation.name }}
        </option>
      </select>
    </div>
  </div>
</div>
